@use "@fukuri-admins/ui/layout" as *;

.Root {
  &__Header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  &__Title {
    font-weight: 600;
    margin-bottom: 8px;
    font-size: 28px;
  }
  &__Description {
    font-size: 14px;
    color: $TextLabel;
    text-align: center;
    margin-bottom: 24px;
  }
  &__Actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 32px;
    margin-top: 7px;
  }
  .loading {
    display: flex;
    justify-content: center;
  }
}
